import { type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const { SlideshowList } = await import('@@routes/slideshow/components/SlideshowList');

            return { Component: SlideshowList };
        },
    },
    {
        path: 'new',
        lazy: async () => {
            const { SlideshowSetupPage } = await import('@@routes/slideshow');

            return { Component: SlideshowSetupPage };
        },
    },
    {
        path: ':id',
        lazy: async () => {
            const { SlideshowDetailPage } = await import('@@routes/slideshow');

            return { Component: SlideshowDetailPage };
        },
        children: [
            {
                // Pathless, so the content stays mounted while a slide modal opens on top of it
                lazy: async () => {
                    const { default: SlideshowContent } =
                        await import('@@routes/slideshow/components/SlideshowContent');

                    return { Component: SlideshowContent };
                },
                errorElement: <ErrorPage />,
                children: [
                    // An explicit `null` tells the router that the empty leaf is on purpose
                    { index: true, element: null },
                    {
                        path: 'slides/bulk',
                        lazy: async () => {
                            const { default: SlideBulkModal } =
                                await import('@@routes/slideshow/components/SlideBulkModal');

                            return { Component: SlideBulkModal };
                        },
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'slides/:slideId',
                        lazy: async () => {
                            const { default: SlideFormModal } =
                                await import('@@routes/slideshow/components/SlideFormModal');

                            return { Component: SlideFormModal };
                        },
                        errorElement: <ErrorPage />,
                    },
                ],
            },
            metadataRoute,
            pushRoute,
        ],
    },
];
